import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { useIntl } from 'react-intl';

function SummaryRowAriba({ children, title, onChange }) {
  const intl = useIntl();

  return (
    <Layout mt="-1px" p={10}>
      <Text w="30%" color="gray-700" variant="body-bold">
        {title}
      </Text>
      <Layout align="flex-start" w="60%">
        {children}
      </Layout>
      {!onChange || (
        <Layout align="flex-start" w="10%">
          <Button
            text={intl.formatMessage({
              id: 'SummaryRowAriba.editButton',
              defaultMessage: 'Edit',
              description: 'Button text to edit the summary row item',
            })}
            variant="action"
            onClick={onChange}
          />
        </Layout>
      )}
    </Layout>
  );
}

export default SummaryRowAriba;
